import { render, staticRenderFns } from "./form-document-signatures.vue?vue&type=template&id=01415502&scoped=true&lang=pug"
import script from "./form-document-signatures.vue?vue&type=script&lang=js"
export * from "./form-document-signatures.vue?vue&type=script&lang=js"
import style0 from "./form-document-signatures.vue?vue&type=style&index=0&id=01415502&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01415502",
  null
  
)

export default component.exports